import React from 'react';

export default class SimpleNav extends React.PureComponent {
  render() {
    return (
      <div className='nav-content'>
        <a href='https://www.oomple.com'>
          <img
            src='//s3.amazonaws.com/splicegroup-publicassets/logo.png?_=202102051545'
            alt='Oomple'
            className='logo'
          />
        </a>
      </div>
    );
  }
}